import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  category: string;
  excerpt: string;
  imageUrl: string;
  author: string;
  readTime: number;
  date: string;
  tags: string[];
  categoryName?: string;
  categorySlug?: string;
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  imageUrl,
  author,
  readTime,
  date,
  categoryName,
  categorySlug,
}: ArticleCardProps) {
  return (
    <Link
      to={`/article/${slug}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all duration-300 overflow-hidden cursor-pointer"
    >
      <div className="aspect-[16/10] overflow-hidden">
        <img
          src={imageUrl}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-4 md:p-5">
        {categoryName && categorySlug && (
          <span className="inline-block px-2 py-0.5 rounded text-xs font-medium bg-primary-50 text-primary-600 mb-2">
            {categoryName}
          </span>
        )}
        <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
          {title}
        </h3>
        <p className="mt-2 text-sm text-foreground-600 line-clamp-2 leading-relaxed">
          {excerpt}
        </p>
        <div className="mt-4 flex items-center gap-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-user-line"></i>
            {author}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {readTime} 分钟
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {date}
          </span>
        </div>
      </div>
    </Link>
  );
}